import { useTranslation } from "react-i18next";

import { Block } from "src/core/components/pdf/shared/Block";
import { MissionsTable } from "src/core/components/pdf/shared/MissionTable";
import { Title } from "src/core/components/pdf/shared/Title";
import { FolderFileType } from "src/core/components/pdf/shared/types";
import { IRiskOption } from "src/core/constants/options";
import { Mission } from "src/core/gql/graphql";
import { isMissionActive } from "src/core/utils/folders";

type MissionsSectionProps = {
  folderFile: FolderFileType;
  missionTypeWithRiskOptions: IRiskOption[];
};

export const MissionsSection = ({
  folderFile,
  missionTypeWithRiskOptions,
}: MissionsSectionProps) => {
  const { t } = useTranslation();

  const missions = (folderFile.currentCustomerFolder?.missions ?? []) as Mission[];

  const activeMissions = missions.filter((mission) => isMissionActive(mission));
  const inactiveMissions = missions.filter((mission) => !isMissionActive(mission));

  return (
    <Block>
      <Title title={t("pdf.sections.missions.title")} />

      <MissionsTable
        missions={activeMissions}
        missionTypeWithRiskOptions={missionTypeWithRiskOptions}
        title={t("pdf.sections.missions.active")}
        isFirstTable
        hasSecondTable={inactiveMissions.length > 0}
      />
      <MissionsTable
        missions={inactiveMissions}
        missionTypeWithRiskOptions={missionTypeWithRiskOptions}
        title={t("pdf.sections.missions.inactive")}
        isInactive
        isFirstTable={activeMissions.length === 0}
      />
    </Block>
  );
};
